/** Página `/contacto`: copy, etiquetas del formulario, validaciones y avisos. */

export const contacto = {
  eyebrow: 'Hablemos',
  titulo: 'Cuéntanos de tu próximo evento',
  lead: 'Te mostramos la plataforma con datos reales de un evento y estimamos qué esperar en el tuyo. Si prefieres, escríbenos directo.',
  planInteres: 'Plan de interés:',
  horario: 'Respondemos en horario hábil, tiempo del centro de México.',

  tipoSolicitud: 'Tipo de solicitud',
  /** El `value` que viaja al backend no se traduce; solo la etiqueta. */
  tipos: {
    demo: 'Agendar demo',
    contacto: 'Contacto',
    loi: 'Letter of Intent',
  },

  perfilPregunta: '¿Cómo te describes?',
  perfiles: {
    marca: 'Marca / Expositor',
    organizador: 'Organizador de eventos',
    otro: 'Otro',
  },

  campos: {
    nombre: 'Nombre',
    empresa: 'Empresa',
    email: 'Correo',
    telefono: 'Teléfono (opcional)',
    mensaje: 'Mensaje',
    mensajePlaceholder:
      'Cuéntanos del evento: fecha, sede, número aproximado de stands o asistentes.',
    /** Campo trampa: invisible para una persona, tentador para un bot. */
    honeypot: 'No llenar',
  },

  errores: {
    nombre: 'Escribe tu nombre.',
    empresa: 'Escribe el nombre de tu empresa.',
    email: 'Escribe un correo válido.',
    mensaje: 'Cuéntanos un poco más (mínimo 10 caracteres).',
  },

  enviar: 'Enviar solicitud',

  estados: {
    /** Respuesta al honeypot: se finge éxito para no darle señal al bot. */
    graciasBot: 'Gracias, recibimos tu mensaje.',
    mailtoAbierto: (correo: string) =>
      `Abrimos tu programa de correo con el mensaje listo para enviar. Si no se abrió nada, tu equipo no tiene uno configurado: copia lo que escribiste y mándanoslo a ${correo}.`,
  },

  /**
   * Lo que el formulario hace de verdad. Reemplaza a `sinBackend`, que
   * describía un estado transitorio —«aún no está configurado»— que dejó de ser
   * transitorio el 2026-09-18: el sitio no tiene backend y no lo va a tener.
   */
  porCorreo: {
    aviso:
      'Este formulario no envía nada por su cuenta: prepara un correo y lo abre en tu programa de correo para que lo revises y lo mandes tú. También puedes escribirnos directo a',
  },

  /** Asuntos del `mailto:` cuando no hay backend configurado. */
  mailto: {
    asuntoDemo: 'Solicitud de demo — ILUMETRIA',
    asuntoLoi: 'Letter of Intent — ILUMETRIA',
    asuntoContacto: 'Contacto — ILUMETRIA',
    nombre: 'Nombre',
    empresa: 'Empresa',
    correo: 'Correo',
    telefono: 'Teléfono',
    perfil: 'Perfil',
    planInteres: 'Plan de interés',
  },
};
